/**
 * Shared SRS signals + storage instance.
 *
 * Extracted from main.tsx so render-time helpers (e.g. quizL1Subtext) can
 * import `signals` without dragging the full app boot graph — Preact render,
 * audio service, situations wiring, lang-core animations — into vitest test
 * files. Production callers continue to import `signals` from `./main.js`
 * via the re-export there.
 */
import { StorageService } from '@kevvykevwin/lang-core/storage';
import { createSrsSignals } from '@kevvykevwin/lang-core/srs';
import type { EnglishCardExt } from './types.js';

export const storage = new StorageService({
  prefix: 'english-',
  version: 1,
  keys: {
    wordProgress: (level: string) => `english-word-progress-${level}`,
    preferences: 'english-preferences',
    sessionStats: 'english-session-stats',
    audioCache: 'english-audio-cache'
  }
});

export const signals = createSrsSignals<EnglishCardExt>({
  storage,
  initialLevel: 'A1',
  initialQuizMode: 'multiple-choice'
});
